import { RemoteResult, StringRequest } from "mangdto"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import { Validator } from "mangutil"

export default class PasswortAendernLogic {
  neuesPasswort?: string = ""
  neuesPasswortWiederholen?: string = ""

  passwortGeaendert: boolean = false

  passwordRules: any[] = Validator.strongPasswordRules
  passwordWiederholenRules: any[] = [
    Validator.strongPasswordRules,
    this.verifyPassword,
  ]

  verifyPassword() {
    if (this.neuesPasswort !== this.neuesPasswortWiederholen) {
      return "Passwörter müssen übereinstimmen"
    }
  }

  passwortAendern() {
    var request = new StringRequest()
    request.param = this.neuesPasswort

    Poster.postUser<RemoteResult<Boolean>>(
      RestPaths.kundePasswortAendernDirekt,
      request,
    ).then((response) => {
      if (response.data.success) {
        this.passwortGeaendert = true
      }
    })
  }
}
